__webpack_require__.p = "/asset-prefix-luxury005/";